// extracted by mini-css-extract-plugin
export var arrow = "arrow-module--arrow--QQiF7";
export var arrowFill = "arrow-module--arrowFill--XMi9g";
export var arrowFillright = "arrow-module--arrowFillright--mgtQT";
export var arrowFilllargeRight = "arrow-module--arrowFilllargeRight--LGOaF";
export var arrowFillbottomRight = "arrow-module--arrowFillbottomRight--0qyr5";
export var bgNeon = "arrow-module--bgNeon--GAo+x";
export var bgBlue = "arrow-module--bgBlue--FqfAx";